import { memo } from 'react';
import { Badge } from '@/hen-ui/atomics/Badge';
import { Flex } from '@/hen-ui/composites/Flex';
import { SponsoredVisitButton } from './SponsoredVisitButton';
import type { SponsoredCardProps } from './types';

type SponsoredCardHeaderProps = Pick<
  SponsoredCardProps,
  | 'sponsorLabel'
  | 'visitHref'
  | 'visitLabel'
  | 'onVisitClick'
  | 'sponsoredVisit'
> & {
  /** When true, only the sponsor badge is shown (visit CTA rendered elsewhere, e.g. modal). */
  hideVisitButton?: boolean;
};

export const SponsoredCardHeader = memo(function SponsoredCardHeader({
  sponsorLabel = 'Sponsored Partner',
  visitHref,
  visitLabel = 'Visit Site',
  onVisitClick,
  sponsoredVisit = true,
  hideVisitButton = false,
}: SponsoredCardHeaderProps) {
  return (
    <Flex
      direction='column'
      direction-md='row'
      align='start'
      justify='between'
      gap='sm'
      className='w-full md:items-start'
    >
      <Badge
        variant='primary'
        size='lg'
        role='note'
        tabIndex={-1}
        className='w-fit max-w-full font-semibold bg-secondary-700'
      >
        {sponsorLabel}
      </Badge>
      {!hideVisitButton && (
        <SponsoredVisitButton
          visitHref={visitHref}
          visitLabel={visitLabel}
          onVisitClick={onVisitClick}
          sponsoredVisit={sponsoredVisit}
          className='shrink-0 px-md hidden w-auto md:inline-flex'
        />
      )}
    </Flex>
  );
});
